import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import styles from './styles.module.css';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const caseIcons = [
  <svg key="0" width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#5BA4CF" strokeWidth="1.8" strokeLinecap="round">
    <rect x="2" y="7" width="22" height="14" rx="2" />
    <path d="M7 7V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2" />
  </svg>,
  <svg key="1" width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#5BA4CF" strokeWidth="1.8" strokeLinecap="round">
    <circle cx="7" cy="19" r="2.5" />
    <circle cx="19" cy="19" r="2.5" />
    <path d="M2 19h3M9 19h8M21 19h3M4 15l2-8h14l2 8" />
  </svg>,
  <svg key="2" width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#5BA4CF" strokeWidth="1.8" strokeLinecap="round">
    <rect x="3" y="3" width="8" height="8" rx="1.5" />
    <rect x="15" y="3" width="8" height="8" rx="1.5" />
    <rect x="3" y="15" width="8" height="8" rx="1.5" />
    <rect x="15" y="15" width="8" height="8" rx="1.5" />
  </svg>,
  <svg key="3" width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#5BA4CF" strokeWidth="1.8" strokeLinecap="round">
    <path d="M3 20l5-5 5 5 5-8 5 3" />
    <path d="M3 5h20" />
  </svg>,
  <svg key="4" width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#5BA4CF" strokeWidth="1.8" strokeLinecap="round">
    <rect x="4" y="3" width="18" height="20" rx="2" />
    <path d="M9 8h8M9 12h8M9 16h5" />
  </svg>,
  <svg key="5" width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#5BA4CF" strokeWidth="1.8" strokeLinecap="round">
    <path d="M13 2L3 7v6c0 5.5 4.3 10.7 10 12 5.7-1.3 10-6.5 10-12V7L13 2z" />
    <polyline points="9 13 11 15 17 9" />
  </svg>,
];

export default function CasosDeUso() {
  const { t } = useTranslation('landing');

  const cases = t('casosDeUso.cases', { returnObjects: true });

  return (
    <motion.section
      id="cases"
      className={styles.section}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <div className={styles.container}>
        <div className={styles.center}>
          <span className={styles.tag}>{t('casosDeUso.tag')}</span>
          <h2 className={styles.title}>{t('casosDeUso.title')}</h2>
          <p className={styles.subtitle}>{t('casosDeUso.subtitle')}</p>
        </div>
        <div className={styles.grid}>
          {cases.map((c, i) => (
            <div key={i} className={styles.card}>
              <div className={styles.ico}>{caseIcons[i]}</div>
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
              <div className={styles.benefit}>{c.benefit}</div>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
